import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

type Props = {
  isVisible: boolean
}
type Emits = {
  (e: 'close')
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ModalOverlay',
  props: {
    isVisible: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "#modal-overlay" }, [
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (_ctx.isVisible)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "modal-overlay",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
            }, [
              _createElementVNode("div", {
                class: "modal-content",
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
              }, [
                _renderSlot(_ctx.$slots, "default")
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}
}

})